<template>
    <div v-if="show" :class="['message', type]" @click="$emit('close', false)">
        <div class="message__bg"></div>
        <div class="message__content">
            <span v-for="(item, index) in content" :key="index" class="d-block">{{ item[0] }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "MessageComponent",
    props: {
        type: {
            type: String,
            required: true,
            default: 'err'
        },
        content: {
            type: Array,
            required: true,
            default: ()=>[]
        },
    },
    data(){
        return {
            show: true,
        }
    },
}
</script>
<style lang="scss" scoped>
.message{
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999999;
    visibility: hidden;
    opacity: 0;
    background: rgba(0,0,0,.5);
    transition: .2s;
    cursor: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAElBMVEUAAAD///////////////////8+Uq06AAAABnRSTlMA/PQm7m0lWMLoAAAAU0lEQVQI12NgdWYAA5MAhkAhAxCLWVGUwVFQGcQ0EhQBYqAwUBAoAibAAhASzIfIQQTBwmBBiDBYECIMFUQwEQoQ2lANQ1iBsBjZOQhHIjsd4SEAdD8PA1JO6p0AAAAASUVORK5CYII='), auto;
    &__bg{
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
    }
    &.err{
        background: rgba(121, 22, 22, .7);
        visibility: visible;
        opacity: 1;
        .message__content{
            width: 100%;
            padding: 30px;
            text-align: center;
            color: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            box-shadow: 0 0 22px 0 rgba(0,0,0,.6);
            background: red;
        }
    }
    &.ok{
        background: rgba(47, 80, 167, .8);
        visibility: visible;
        opacity: 1;
        .message__content{
            color: #0F1E47;
            background: #fff;
            width: 100%;
            padding: 30px;
            text-align: center;
            position: absolute;
            bottom: 0;
            left: 0;
            box-shadow: 0 0 22px 0 rgba(0,0,0,.6);
            p{
                margin: 0;
            }
            @media (max-width: 400px) {
                padding: 30px;
            }
        }
    }
}

</style>
